import type { Client, RequestContext } from "../client";
import type { ArgoCDApplicationResource, ArgoCDGatewayResource } from "../resources/index";
type ListArgoCDGatewaysArgs = {
    name: string;
    partialName: string;
    environmentIds: string[];
};
export type UpdateArgoCDGatewayCommand = {
    SpaceId: string;
    Id: string;
    Name: string;
    EnvironmentIds: string[];
    WebUIUri: string | null;
};
export class ArgoCDGatewayRepository {
    protected client: Client;
    baseUrl = "~/api/spaces/{spaceId}/argocdgateways";
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    async get(id: string): Promise<ArgoCDGatewayResource> {
        const r = await this.client.get<{
            Resource: ArgoCDGatewayResource;
        }>(this.requestContext, `${this.baseUrl}/{id}`, { id });
        return r.Resource;
    }
    async save(command: UpdateArgoCDGatewayCommand): Promise<ArgoCDGatewayResource> {
        const r = await this.client.post<{
            Resource: ArgoCDGatewayResource;
        }>(this.requestContext, `${this.baseUrl}/{id}`, command, { id: command.Id });
        return r.Resource;
    }
    async delete(id: string): Promise<void> {
        await this.client.delete(this.requestContext, `${this.baseUrl}/{id}`, undefined, { id });
    }
    async listApps(id: string): Promise<ArgoCDApplicationResource[]> {
        const r = await this.client.get<{
            Resources: ArgoCDApplicationResource[];
        }>(this.requestContext, `${this.baseUrl}/{id}/applications`, { id });
        return r.Resources;
    }
}
